/**
 * @generated SignedSource<<03009c763c2fa81d9ddafd9c6b0a20eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveInstallmentCompleted_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCompleted_query">;
  readonly " $fragmentType": "PaymentActiveInstallmentCompleted_query";
};
export type PaymentActiveInstallmentCompleted_query$key = {
  readonly " $data"?: PaymentActiveInstallmentCompleted_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveInstallmentCompleted_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveInstallmentCompleted_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCompleted_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "02a9d00911c53876bf28b1a0eb511573";

export default node;
